export function productSlug(product) {
  const source = product?.slug || product?.name || product;
  return String(source || '')
    .trim()
    .toLowerCase()
    .replace(/&/g, ' and ')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

export function productPath(product) {
  const slug = productSlug(product);
  if (slug) return `/products/${slug}`;
  return product?.id ? `/products/${product.id}` : '/products';
}
